import React, { Component } from 'react';
import { markdownToHtml } from '$lib/markdown';
import PassageSource from '../PassageSource';
import PassageChooseSentence from './PassageChooseSentence';
import styles from './styles.scss';

class QuizPassageChooseSentence extends Component {
  renderPassage() {
    const { handleChoice, quizObj, quizState } = this.props;
    const { quiz } = quizObj;
    const { evaluated } = quiz;
    const { passageSource } = evaluated;

    return (
      <div className={styles.passage}>
        <PassageChooseSentence
          handleChoice={handleChoice}
          quizObj={quizObj}
          quizState={quizState}
        />
        <PassageSource className={styles.passageSource} passageSource={passageSource} />
      </div>
    );
  }

  render() {
    const { quizObj } = this.props;
    const { quiz } = quizObj;
    const { prompt } = quiz;

    return (
      <div className={styles.layout}>
        <div className={styles.prompt}>{markdownToHtml(prompt)}</div>
        {this.renderPassage()}
      </div>
    );
  }
}

export default QuizPassageChooseSentence;
